import { render, staticRenderFns } from "./FeedBackForm.vue?vue&type=template&id=6b95b30a&scoped=true&"
import script from "./FeedBackForm.vue?vue&type=script&lang=js&"
export * from "./FeedBackForm.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackForm.vue?vue&type=style&index=0&id=6b95b30a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b95b30a",
  null
  
)

export default component.exports